import WithPermissionRestricted from '../../../../../general/hoc/WithPermissionRestricted'
import { CouponTransactionsDashboardProvider } from './CouponTransactionsDashboard'
import CouponTransactionsDashboardLayout from './CouponTransactionsDashboardLayout'

function CouponTransactionsDashboardWrapper() {
  return (
    <CouponTransactionsDashboardProvider>
      <CouponTransactionsDashboardLayout />
    </CouponTransactionsDashboardProvider>
  )
}

export default WithPermissionRestricted(CouponTransactionsDashboardWrapper, 'FILTERS', [
  'promotions',
  'GetAllPromotions',
])
